import React from 'react'

function Plus ({ className, fill }) {
  return (
    <svg fill={fill} className={className} width='12' height='12' viewBox='0 0 12 12'>
      <g transform='translate(-3.6 -3.6)'>
        <path d='M96,202.668h12v1.091H96Zm0,0' transform='translate(-92.4 -193.613)' />
        <path d='M202.668,96h1.091v12h-1.091Zm0,0' transform='translate(-193.613 -92.4)' />
      </g>
    </svg>
  )
}

Plus.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default Plus
